import { Map, OrderedMap, List, fromJS } from 'immutable';

// Constants
import UpdateAiSettingsConstants from 'Shared/constants/UpdateAiSettings.constants';

const initialState = Map({
  [UpdateAiSettingsConstants.State.TEMPLATE_BY_TEMPLATE_SLUG]: OrderedMap(),
  [UpdateAiSettingsConstants.State.UPDATE_AI_SETTINGS_BY_SLUG]: OrderedMap(),
  [UpdateAiSettingsConstants.State.TEMPLATE_SECTIONS_BY_SLUG]: OrderedMap(),
  [UpdateAiSettingsConstants.State.CURRENTLY_GENERATING_SECTION_SLUGS]: List(),
});

export const UpdateAiSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UpdateAiSettingsConstants.Actions.FETCH_DEFAULT_TEMPLATES_SUCCESS:
      return state.updateIn([UpdateAiSettingsConstants.State.TEMPLATE_BY_TEMPLATE_SLUG], (existing = OrderedMap()) =>
        existing.merge(
          OrderedMap(
            Object.values(action.payload.updateAiTemplate).map(item => [
              item.attributes.slug,
              Map(fromJS(item.attributes)),
            ])
          )
        )
      );
    case UpdateAiSettingsConstants.Actions.CREATE_UPDATE_AI_SETTING_SUCCESS:
    case UpdateAiSettingsConstants.Actions.FETCH_UPDATE_AI_SETTING_SUCCESS:
    case UpdateAiSettingsConstants.Actions.UPDATE_UPDATE_AI_SETTING_SUCCESS:
    case UpdateAiSettingsConstants.Actions.UPDATE_UPDATE_AI_SETTING_REPORT_SUCCESS:
    case UpdateAiSettingsConstants.Actions.FETCH_UPDATE_AI_REPORT_SUCCESS:
    case UpdateAiSettingsConstants.Actions.FETCH_UPDATE_AI_REPORTS_SUCCESS:
      return state
        .updateIn([UpdateAiSettingsConstants.State.UPDATE_AI_SETTINGS_BY_SLUG], (existing = OrderedMap()) =>
          existing.merge(
            OrderedMap(
              Object.values(action.payload.updateAiSetting).map(item => [
                item.attributes.slug,
                Map(
                  fromJS({
                    ...item.attributes,
                    dataSources: item.relationships?.updateAiSettingDataSources.data.map(ds => {
                      return action.payload?.updateAiSettingDataSource[ds.id].attributes;
                    }),
                    templateSectionSlugs: item.relationships?.updateAiTemplateSections.data.map(d => {
                      return action.payload?.updateAiTemplateSection[d.id].attributes.slug;
                    }),
                    // reportSlug: item.relationships?.updateAiReports.data.map(d => {
                    //   return action.payload?.updateAiTemplateSection[d.id].attributes.slug;
                    // }),
                  })
                ),
              ])
            )
          )
        )
        .updateIn([UpdateAiSettingsConstants.State.TEMPLATE_BY_TEMPLATE_SLUG], (existing = OrderedMap()) =>
          existing.merge(
            OrderedMap(
              Object.values(action.payload.updateAiTemplate).map(item => [
                item.attributes.slug,
                Map(fromJS(item.attributes)),
              ])
            )
          )
        )
        .updateIn([UpdateAiSettingsConstants.State.TEMPLATE_SECTIONS_BY_SLUG], (existing = OrderedMap()) =>
          existing.merge(
            OrderedMap(
              Object.values(action.payload.updateAiTemplateSection).map(item => [
                item.attributes.slug,
                Map(fromJS(item.attributes)),
              ])
            )
          )
        )
        .updateIn([UpdateAiSettingsConstants.State.REPORTS_BY_REPORT_SLUG], (existing = OrderedMap()) =>
          existing.merge(
            OrderedMap(
              Object.values(action.payload.updateAiReport).map(item => [
                item.attributes.slug,
                Map(fromJS(item.attributes)),
              ])
            )
          )
        );

    case UpdateAiSettingsConstants.Actions.CREATE_UPDATE_AI_TEMPLATE_SECTION_SUCCESS:
      return state
        .updateIn([UpdateAiSettingsConstants.State.TEMPLATE_SECTIONS_BY_SLUG], (existing = OrderedMap()) =>
          existing.merge(
            OrderedMap(
              Object.values(action.payload.data.updateAiTemplateSection).map(item => [
                item.attributes.slug,
                Map(fromJS(item.attributes)),
              ])
            )
          )
        )
        .updateIn([UpdateAiSettingsConstants.State.REPORTS_BY_REPORT_SLUG], (existing = OrderedMap()) =>
          existing.merge(
            OrderedMap(
              Object.values(action.payload.data.updateAiReport).map(item => [
                item.attributes.slug,
                Map(fromJS(item.attributes)),
              ])
            )
          )
        )
        .updateIn(
          [UpdateAiSettingsConstants.State.UPDATE_AI_SETTINGS_BY_SLUG, action.payload.slug, 'templateSectionSlugs'],
          (existing = List()) =>
            existing.merge(Object.values(action.payload.data.updateAiTemplateSection).map(item => item.attributes.slug))
        );

    case UpdateAiSettingsConstants.Actions.UPDATE_UPDATE_AI_TEMPLATE_SECTION_SUCCESS:
      return state.updateIn([UpdateAiSettingsConstants.State.TEMPLATE_SECTIONS_BY_SLUG], (existing = OrderedMap()) =>
        existing.merge(
          OrderedMap(
            Object.values(action.payload.updateAiTemplateSection).map(item => [
              item.attributes.slug,
              Map(fromJS(item.attributes)),
            ])
          )
        )
      );

    case UpdateAiSettingsConstants.Actions.REMOVE_UPDATE_AI_TEMPLATE_SECTION_SUCCESS:
      return state.deleteIn([
        UpdateAiSettingsConstants.State.TEMPLATE_SECTIONS_BY_SLUG,
        action.payload.templateSectionSlug,
      ]);

    case UpdateAiSettingsConstants.Actions.CATCH_UPDATE_AI_SOCKET_SUCCESS:
      return state
        .updateIn(
          [UpdateAiSettingsConstants.State.REPORTS_BY_REPORT_SLUG, action.payload.reportSlug, 'body'],
          (existing = List()) => {
            return existing
              .filterNot(s => {
                return s.get('templateSectionSlug') === action.payload.body.templateSectionSlug;
              })
              .push(Map(fromJS(action.payload.body)));
          }
        )
        .updateIn([UpdateAiSettingsConstants.State.CURRENTLY_GENERATING_SECTION_SLUGS], (existing = List()) => {
          if (action.payload.body.progressMessage) return existing;
          return existing.filter(e => e !== action.payload.body.templateSectionSlug);
        });

    case UpdateAiSettingsConstants.Actions.ADD_CURRENTLY_GENERATING_SECTION_SLUGS:
      return state.updateIn(
        [UpdateAiSettingsConstants.State.CURRENTLY_GENERATING_SECTION_SLUGS],
        (existing = List()) => {
          return existing.merge(action.payload);
        }
      );

    case UpdateAiSettingsConstants.Actions.REMOVE_CURRENTLY_GENERATING_SECTION_SLUGS:
      return state.updateIn(
        [UpdateAiSettingsConstants.State.CURRENTLY_GENERATING_SECTION_SLUGS],
        (existing = List()) => {
          return existing.filter(e => !action.payload.includes(e));
        }
      );

    case UpdateAiSettingsConstants.Actions.DELETE_UPDATE_AI_SETTING_REPORT_SUCCESS:
      return state.deleteIn([UpdateAiSettingsConstants.State.REPORTS_BY_REPORT_SLUG, action.payload.reportSlug]);

    default:
      return state;
  }
};
